"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OverlayPortal = void 0;
var preact_1 = require("preact");
var _a = KalturaPlayer.ui, connect = _a.redux.connect, shell = _a.reducers.shell;
var createPortal = KalturaPlayer.ui.createPortal;
var PORTAL_CLASS = '.overlay-portal';
var PLAYKIT_OVERLAY_CLASS = '.playkit-overlay';
var OVERLAY_ACTIVE_CLASS_NAME = 'playkit-overlay-active';
var mapStateToProps = function (state) { return ({
    targetId: state.config.targetId
}); };
var mapDispatchToProps = function (dispatch) {
    return {
        addPlayerClass: function () { return dispatch(shell.actions.addPlayerClass(OVERLAY_ACTIVE_CLASS_NAME)); }
    };
};
var OverlayPortal = /** @class */ (function (_super) {
    __extends(OverlayPortal, _super);
    function OverlayPortal() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.playerContainer = document.getElementById(_this.props.targetId) || document;
        return _this;
    }
    OverlayPortal.prototype.componentWillUnmount = function () {
        var _this = this;
        setTimeout(function () {
            if (_this.playerContainer.querySelector("".concat(PORTAL_CLASS, " > ").concat(PLAYKIT_OVERLAY_CLASS))) {
                // keep .playkit-overlay-active class in case OverlayPortal has playkit-ui Overlay as children
                _this.props.addPlayerClass();
            }
            // use timeout 0 to make sure check happens after components updated
        }, 0);
    };
    OverlayPortal.prototype.render = function () {
        return createPortal(this.props.children, this.playerContainer.querySelector(PORTAL_CLASS));
    };
    OverlayPortal = __decorate([
        connect(mapStateToProps, mapDispatchToProps)
    ], OverlayPortal);
    return OverlayPortal;
}(preact_1.Component));
exports.OverlayPortal = OverlayPortal;
//# sourceMappingURL=index.js.map